export default function ({ $axios, redirect }) {
    //Authorization
    $axios.setHeader('Content-Type', 'application/json')
}